/* eslint-disable @typescript-eslint/no-explicit-any */
import { Outlet, useLoaderData, useMatches } from 'react-router'

import Header from '~/components/Navigation/Header/Header'
import { Toaster } from '~/components/UI/General/Sonner/Sonner'
import { ModeToggle } from '~/~DevelopmentComps/DevelopmentOnly/TestButton/mode-toggle'
import Footer from '~/components/Navigation/Footer/Footer'
import { QueryClient, dehydrate } from '@tanstack/query-core'
import { Navigation } from './~queries/navQuery'
import Ticker from '~/components/Navigation/Ticker/Ticker'

export async function loader() {
  const queryClient = new QueryClient()

  await queryClient.prefetchQuery({
    queryKey: ['navData'],
    queryFn: () => Navigation()
  })

  return { dehydratedStateLayout: dehydrate(queryClient) }
}

const Layout = () => {
  const matches = useMatches()
    .map(match => match.data)
    .filter((data): data is { headerColour?: string; dehydratedState?: any } =>
      Boolean((data as any)?.headerColour || (data as any)?.dehydratedState)
    )
    .map(data => data)[0]

  const match =
    matches.headerColour ||
    matches.dehydratedState?.queries[0]?.state?.data.heroContent
      ?.backgroundColour ||
    matches.dehydratedState?.queries[0]?.state?.data.heroContentAvantGarde
      ?.backgroundColour ||
    ('white' as AllBackgroundColours)

  const contentType =
    matches.dehydratedState?.queries[0]?.state?.data?.sys?.contentTypeId ??
    'pageStandard'

  const loaderData = useLoaderData<typeof loader>()

  const data = loaderData?.dehydratedStateLayout?.queries[0]?.state
    ?.data as never as {
    footer: any
    navItems: any
    ticker: any
  }

  const ticker = data?.ticker.filter(
    (t: any) =>
      (t.contentType.length === 0 ||
        t.contentType.find((ct: any) => ct.id === contentType)) &&
      new Date(t.date.from) <= new Date(Date.now()) &&
      new Date(t.date.to) >= new Date(Date.now())
  )

  return (
    <>
      {ticker && ticker.length > 0 && <Ticker content={ticker[0]} />}
      <Header
        data={data?.navItems}
        bgColour={match}
        ticker={ticker.length > 0}
      />

      <main className='relative'>
        <div className='absolute top-0 right-0 left-0 z-10 container flex justify-end'>
          <ModeToggle />
        </div>
        <Outlet />
      </main>

      <Footer content={data?.footer} />

      <Toaster />
    </>
  )
}

export default Layout
